import * as actionTypes from "./cartActionTypes";

export const clearCart = () => ({
  type: actionTypes.CLEAR_CART,
});

export const setCartExpiration = (cartExpMinutes: number) => {
  return {
    type: actionTypes.SET_CART_EXPIRATION,
    cartExpMinutes,
  };
};

export const updateCart = (obj: any) => {
  return {
    type: actionTypes.UPDATE_CART,
    obj,
  };
};